/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

/* eslint-disable */
var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(ContentType || (ContentType = {}));
var HttpClient = /** @class */ (function () {
    function HttpClient(apiConfig) {
        var _a;
        var _this = this;
        if (apiConfig === void 0) { apiConfig = {}; }
        this.baseUrl = 'https://duck.forbes.ru';
        this.securityData = null;
        this.abortControllers = new Map();
        this.customFetch = function () {
            var fetchParams = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                fetchParams[_i] = arguments[_i];
            }
            return fetch.apply(void 0, fetchParams);
        };
        this.baseApiParams = {
            credentials: 'same-origin',
            headers: {},
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
        };
        this.setSecurityData = function (data) {
            _this.securityData = data;
        };
        this.contentFormatters = (_a = {},
            _a[ContentType.Json] = function (input) {
                return input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input;
            },
            _a[ContentType.FormData] = function (input) {
                return Object.keys(input || {}).reduce(function (formData, key) {
                    var property = input[key];
                    formData.append(key, property instanceof Blob
                        ? property
                        : typeof property === 'object' && property !== null
                            ? JSON.stringify(property)
                            : "".concat(property));
                    return formData;
                }, new FormData());
            },
            _a[ContentType.UrlEncoded] = function (input) { return _this.toQueryString(input); },
            _a);
        this.createAbortSignal = function (cancelToken) {
            if (_this.abortControllers.has(cancelToken)) {
                var abortController_1 = _this.abortControllers.get(cancelToken);
                if (abortController_1) {
                    return abortController_1.signal;
                }
                return void 0;
            }
            var abortController = new AbortController();
            _this.abortControllers.set(cancelToken, abortController);
            return abortController.signal;
        };
        this.abortRequest = function (cancelToken) {
            var abortController = _this.abortControllers.get(cancelToken);
            if (abortController) {
                abortController.abort();
                _this.abortControllers.delete(cancelToken);
            }
        };
        this.request = function (_a) { return __awaiter(_this, void 0, void 0, function () {
            var secureParams, _b, requestParams, queryString, payloadFormatter, responseFormat;
            var _this = this;
            var body = _a.body, secure = _a.secure, path = _a.path, type = _a.type, query = _a.query, format = _a.format, baseUrl = _a.baseUrl, cancelToken = _a.cancelToken, params = __rest(_a, ["body", "secure", "path", "type", "query", "format", "baseUrl", "cancelToken"]);
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = (typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
                            this.securityWorker;
                        if (!_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.securityWorker(this.securityData)];
                    case 1:
                        _b = (_c.sent());
                        _c.label = 2;
                    case 2:
                        secureParams = (_b) ||
                            {};
                        requestParams = this.mergeRequestParams(params, secureParams);
                        queryString = query && this.toQueryString(query);
                        payloadFormatter = this.contentFormatters[type || ContentType.Json];
                        responseFormat = format || requestParams.format;
                        return [2 /*return*/, this.customFetch("".concat(baseUrl || this.baseUrl || '').concat(path).concat(queryString ? "?".concat(queryString) : ''), __assign(__assign({}, requestParams), { headers: __assign(__assign({}, (type && type !== ContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), signal: cancelToken ? this.createAbortSignal(cancelToken) : void 0, body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body) })).then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                                var r, data, _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            r = response;
                                            r.data = null;
                                            r.error = null;
                                            if (!!responseFormat) return [3 /*break*/, 1];
                                            _a = r;
                                            return [3 /*break*/, 3];
                                        case 1: return [4 /*yield*/, response[responseFormat]()
                                                .then(function (data) {
                                                if (r.ok) {
                                                    r.data = data;
                                                }
                                                else {
                                                    r.error = data;
                                                }
                                                return r;
                                            })
                                                .catch(function (e) {
                                                r.error = e;
                                                return r;
                                            })];
                                        case 2:
                                            _a = _b.sent();
                                            _b.label = 3;
                                        case 3:
                                            data = _a;
                                            if (cancelToken) {
                                                this.abortControllers.delete(cancelToken);
                                            }
                                            if (!response.ok)
                                                throw data;
                                            return [2 /*return*/, data];
                                    }
                                });
                            }); })];
                }
            });
        }); };
        Object.assign(this, apiConfig);
    }
    HttpClient.prototype.encodeQueryParam = function (key, value) {
        var encodedKey = encodeURIComponent(key);
        return "".concat(encodedKey, "=").concat(encodeURIComponent(typeof value === 'number' ? value : "".concat(value)));
    };
    HttpClient.prototype.addQueryParam = function (query, key) {
        return this.encodeQueryParam(key, query[key]);
    };
    HttpClient.prototype.addArrayQueryParam = function (query, key) {
        var _this = this;
        var value = query[key];
        return value.map(function (v) { return _this.encodeQueryParam(key, v); }).join('&');
    };
    HttpClient.prototype.toQueryString = function (rawQuery) {
        var _this = this;
        var query = rawQuery || {};
        var keys = Object.keys(query).filter(function (key) { return 'undefined' !== typeof query[key]; });
        return keys
            .map(function (key) { return (Array.isArray(query[key]) ? _this.addArrayQueryParam(query, key) : _this.addQueryParam(query, key)); })
            .join('&');
    };
    HttpClient.prototype.addQueryParams = function (rawQuery) {
        var queryString = this.toQueryString(rawQuery);
        return queryString ? "?".concat(queryString) : '';
    };
    HttpClient.prototype.mergeRequestParams = function (params1, params2) {
        return __assign(__assign(__assign(__assign({}, this.baseApiParams), params1), (params2 || {})), { headers: __assign(__assign(__assign({}, (this.baseApiParams.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    };
    return HttpClient;
}());
/**
 * @title Duck
 * @version 0.0.0
 * @license UNLICENSED
 * @baseUrl https://duck.forbes.ru
 * @contact forbesrussia <forbesrussia@yandex.ru>
 *
 * API for Forbes administration, based on a Drupal-generated database
 */
var Api = /** @class */ (function (_super) {
    __extends(Api, _super);
    function Api() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.auth = {
            /**
             * @description Authorizes the user
             *
             * @tags auth
             * @name Login
             * @summary Login
             * @request POST:/auth/login
             * @secure
             * @response `200` `JWT` Authorized
             * @response `403` `Error` Invalid credentials
             */
            login: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/auth/login", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * @description Refresh access token
             *
             * @tags auth
             * @name RefreshAccessToken
             * @summary RefreshAccessToken
             * @request GET:/auth/refresh
             * @secure
             * @response `200` `{ token?: string, refreshToken?: string }` OK
             */
            refreshAccessToken: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/auth/refresh", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags auth
             * @name PostAuthAdminLogin
             * @summary Аутентификация в панель администратора
             * @request POST:/auth/admin_login
             * @secure
             * @response `200` `JWT` OK
             */
            postAuthAdminLogin: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/auth/admin_login", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags auth
             * @name GetAuthYandexAuthData
             * @summary Поинт для получения авторизационных данных в Яндекс OAuth
             * @request GET:/auth/yandex_auth_data
             * @secure
             * @response `200` `{ token?: string, email?: string, status?: number, expires_in?: number, created_at?: number }` OK
             */
            getAuthYandexAuthData: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/auth/yandex_auth_data", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
        };
        _this.pub = {
            /**
             * No description
             *
             * @name PostPubLoginVk
             * @summary Login VK
             * @request POST:/pub/login_vk
             * @secure
             * @response `200` `JWT` OK
             */
            postPubLoginVk: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/login_vk", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostPubLoginGoogle
             * @summary Login Google
             * @request POST:/pub/login_google
             * @secure
             * @response `200` `JWT` OK
             * @response `0` `JWT`
             */
            postPubLoginGoogle: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/login_google", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostPubLoginYandex
             * @summary Login Yandex
             * @request POST:/pub/login_yandex
             * @secure
             * @response `200` `JWT` OK
             * @response `0` `JWT`
             */
            postPubLoginYandex: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/login_yandex", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostPubLoginMailru
             * @summary Login Mail.ru
             * @request POST:/pub/login_mailru
             * @secure
             * @response `200` `JWT` OK
             * @response `0` `JWT`
             */
            postPubLoginMailru: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/login_mailru", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostAuthReg
             * @summary User registration
             * @request POST:/pub/reg
             * @secure
             * @response `204` `void` No Content
             */
            postAuthReg: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/reg", method: 'POST', body: data, secure: true, type: ContentType.Json }, params));
            },
            /**
             * No description
             *
             * @name PostAuthRegConfirm
             * @summary User registration confirmation
             * @request POST:/pub/reg_confirm
             * @secure
             * @response `200` `JWT` OK
             */
            postAuthRegConfirm: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/reg_confirm", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostPubEmailConfirm
             * @summary Email changing confirmation
             * @request POST:/pub/email_confirm
             * @secure
             * @response `200` `User` OK
             * @response `0` `User`
             */
            postPubEmailConfirm: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/email_confirm", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostPubEmailRecovery
             * @summary Email recovery confirmation
             * @request POST:/pub/email_recovery
             * @secure
             * @response `200` `User` OK
             * @response `0` `User`
             */
            postPubEmailRecovery: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/email_recovery", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostPubRecovery
             * @summary Password recovery
             * @request POST:/pub/recovery
             * @secure
             * @response `204` `void` No Content
             */
            postPubRecovery: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/recovery", method: 'POST', body: data, secure: true, type: ContentType.Json }, params));
            },
            /**
             * No description
             *
             * @name PostPubNewPassword
             * @summary Set new password
             * @request POST:/pub/new_password
             * @secure
             * @response `200` `User` OK
             */
            postPubNewPassword: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/new_password", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * @description Use terms to find specific materials
             *
             * @tags pub
             * @name FindArticles
             * @summary FindArticles
             * @request GET:/pub/search
             * @secure
             * @response `200` `{ results?: ({ id?: number, subtitle?: string, body?: string, title?: string, type?: string, url_alias?: string, time?: number, priority?: number })[], counts?: { total?: number, news?: number, story?: number, photogallery?: number, video?: number, podcasts?: number, rating?: number, profile?: number } }` OK
             */
            findArticles: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/search", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * @description Get list data by id or slug
             *
             * @name GetPubListById
             * @summary GetPubListByID
             * @request GET:/pub/lists/{id}
             * @secure
             * @response `200` `ListWithArticles` OK
             */
            getPubListById: function (id, query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/lists/".concat(id), method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubArticleId
             * @summary Get article
             * @request GET:/pub/article/{id}
             * @secure
             * @response `200` `PubArticle` OK
             */
            getPubArticleId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/article/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * @description Get public article by url alias
             *
             * @name GetPubArticleByAlias
             * @summary Get article by alias
             * @request GET:/pub/article
             * @secure
             * @response `200` `PubArticle` OK
             */
            getPubArticleByAlias: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/article", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubGeneral
             * @summary Your GET endpoint
             * @request GET:/pub/general
             * @secure
             * @response `200` `{ data?: (PubArticle | TaxonomyData), dataType?: string }` OK
             */
            getPubGeneral: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/general", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubRatings
             * @summary getPubRatings
             * @request GET:/pub/ratings
             * @secure
             * @response `200` `(Rating)[]` OK
             */
            getPubRatings: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/ratings", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubRatingById
             * @summary GetPubRatingByID
             * @request GET:/pub/ratings/{id}
             * @secure
             * @response `200` `Rating` OK
             */
            getPubRatingById: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/ratings/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * @description Get public rating fields list by id
             *
             * @name GetPubRatingFieldsList
             * @summary getPubRatingFieldsList
             * @request GET:/pub/ratings/{id}/fields
             * @secure
             * @response `200` `(RatingField)[]` OK
             */
            getPubRatingFieldsList: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/ratings/".concat(id, "/fields"), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubRatingFieldValues
             * @summary GetPubRatingFieldValues
             * @request GET:/pub/ratings/{id}/field_values
             * @secure
             * @response `200` `(RatingFieldValue)[]` OK
             */
            getPubRatingFieldValues: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/ratings/".concat(id, "/field_values"), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubArticles
             * @summary Get articles
             * @request GET:/pub/articles
             * @secure
             * @response `200` `(PubArticle)[]` OK
             */
            getPubArticles: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/articles", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubTax
             * @summary Your GET endpoint
             * @request GET:/pub/tax
             * @secure
             * @response `200` `TaxonomyData` OK
             */
            getPubTax: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/tax", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubTaxId
             * @summary Your GET endpoint
             * @request GET:/pub/tax/{id}
             * @secure
             * @response `200` `TaxonomyData` OK
             */
            getPubTaxId: function (id, query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/tax/".concat(id), method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name Subscribe
             * @summary Subscribe
             * @request POST:/pub/subscribe
             * @secure
             */
            subscribe: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/subscribe", method: 'POST', query: query, secure: true }, params));
            },
            /**
             * No description
             *
             * @name GetPubPopular
             * @summary Your GET endpoint
             * @request GET:/pub/popular
             * @secure
             * @response `200` `({ url?: string, title?: string })[]` OK
             */
            getPubPopular: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/popular", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubPodcasts
             * @summary Your GET endpoint
             * @request GET:/pub/podcasts
             * @secure
             * @response `200` `(TaxonomyData)[]` OK
             */
            getPubPodcasts: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/podcasts", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubSpecial
             * @summary Your GET endpoint
             * @request GET:/pub/special
             * @secure
             * @response `200` `(PubArticle)[]` OK
             */
            getPubSpecial: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/special", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubPreviewToken
             * @summary Your GET endpoint
             * @request GET:/pub/preview/{token}
             * @secure
             * @response `200` `PubArticle` OK
             */
            getPubPreviewToken: function (token, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/preview/".concat(token), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubNew
             * @summary Your GET endpoint
             * @request GET:/pub/new
             * @secure
             * @response `200` `(PubArticle)[]` OK
             */
            getPubNew: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/new", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubAnons
             * @summary GetAnons
             * @request GET:/pub/anons
             * @secure
             * @response `200` `{ id?: number, title?: string, date?: number, month?: number, cover?: File }` OK
             */
            getPubAnons: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/anons", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubPaywallPackages
             * @summary Get paywall packages
             * @request GET:/pub/paywall_packages
             * @secure
             * @response `200` `(PaywallPackage)[]` OK
             */
            getPubPaywallPackages: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/paywall_packages", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubFcongressLists
             * @summary Get fconrgess lists
             * @request GET:/pub/fcongress_lists
             * @secure
             * @response `200` `(List)[]` OK
             */
            getPubFcongressLists: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/fcongress_lists", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubActual
             * @summary Get actual materials
             * @request GET:/pub/actual
             * @secure
             * @response `200` `(PubArticle)[]` OK
             */
            getPubActual: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/actual", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubActualSport
             * @summary Get actual sport materials
             * @request GET:/pub/actual_sport
             * @secure
             * @response `200` `(PubArticle)[]` OK
             * @response `0` `(PubArticle)[]`
             */
            getPubActualSport: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/actual_sport", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubBrandvoices
             * @summary Get brandvoices
             * @request GET:/pub/brandvoices
             * @secure
             * @response `200` `{ name?: string, description?: string, id?: number, url_alias?: string }` OK
             */
            getPubBrandvoices: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/brandvoices", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubArticlesCount
             * @summary Get articles count by types
             * @request GET:/pub/articles/count
             * @secure
             * @response `200` `{ all?: number, news?: number, story?: number, photogallery?: number, video?: number, podcasts?: number, rating?: number, profile?: number }` OK
             */
            getPubArticlesCount: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/articles/count", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Опросы\Тесты\Голосования
             * @name GetPubPollsId
             * @summary Получить в публичном виде опрос
             * @request GET:/pub/polls/{id}
             * @secure
             * @response `200` `Polls` OK
             */
            getPubPollsId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/polls/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubArticlesCommercial
             * @summary Get commercial articles
             * @request GET:/pub/articles/commercial
             * @secure
             * @response `200` `(PubArticle)[]` OK
             */
            getPubArticlesCommercial: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/articles/commercial", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Меню
             * @name GetApiPubMenusId
             * @summary Поинт для публичного просмотра информации по конкретному меню
             * @request GET:/pub/menus/{slug}
             * @secure
             * @response `200` `Menu` OK
             * @response `400` `{ message?: string }` Bad Request
             */
            getApiPubMenusId: function (slug, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/menus/".concat(slug), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Меню
             * @name GetPubMenus
             * @summary Поинт для публичного просмотра информации по списку меню
             * @request GET:/pub/menus
             * @secure
             * @response `200` `(Menu)[]` OK
             */
            getPubMenus: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/menus", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubWaterfall
             * @summary Get waterfall
             * @request GET:/pub/waterfall
             * @secure
             * @response `200` `{ base?: ({ id?: number, title?: string, type?: string, time?: number, url?: string, node_type?: string, sections?: ({ id?: number, name?: string, url?: string })[], tags?: ({ id?: number, name?: string, url?: string })[] })[], fixed?: (any)[] }` OK
             */
            getPubWaterfall: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/waterfall", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostPubAdvForm
             * @summary Handle advertising form
             * @request POST:/pub/adv_form
             * @secure
             * @response `200` `void` OK
             */
            postPubAdvForm: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/adv_form", method: 'POST', body: data, secure: true, type: ContentType.Json }, params));
            },
            /**
             * No description
             *
             * @name GetPubSalutespeechAccessToken
             * @summary Get SaluteSpeech access token
             * @request GET:/pub/salutespeech_access_token
             * @secure
             * @response `200` `{ access_token?: string, expires_at?: number }`
             */
            getPubSalutespeechAccessToken: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/salutespeech_access_token", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubMarusiaV1Blocks
             * @summary Get article text blocks for Marusia
             * @request GET:/pub/marusia/v1/blocks
             * @secure
             * @response `200` `{ meta?: { document?: { document_id?: number, title?: string, block_total?: number, updated_at?: number } }, blocks?: ({ block_number?: number, text?: string })[] }`
             */
            getPubMarusiaV1Blocks: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/marusia/v1/blocks", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubSalutespeech
             * @summary Get SaluteSpeech audio
             * @request GET:/pub/salutespeech
             * @secure
             * @response `200` `object`
             */
            getPubSalutespeech: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/salutespeech", method: 'GET', query: query, secure: true }, params));
            },
            /**
             * No description
             *
             * @name GetPubFranchisesTariffs
             * @summary Get public franchise tariffs
             * @request GET:/pub/franchises/tariffs
             * @secure
             * @response `200` `(FranchiseTariff)[]` OK
             */
            getPubFranchisesTariffs: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/franchises/tariffs", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Франшизы
             * @name GetPubFranchises
             * @summary Получить список франшиз при помощи сортировки
             * @request GET:/pub/franchises
             * @secure
             * @response `200` `ListWithArticles` OK
             */
            getPubFranchises: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/franchises", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Франшизы
             * @name GetPubFranchisesSimilarId
             * @summary Получение "Похожие франшизы"
             * @request GET:/pub/franchises/similar/{id}
             * @secure
             * @response `200` `ListWithArticles` OK
             */
            getPubFranchisesSimilarId: function (id, query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/franchises/similar/".concat(id), method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Франшизы
             * @name GetPubActivityCategory
             * @summary Получение списка значений по полю "Вид деятельности"
             * @request GET:/pub/activity/category
             * @secure
             * @response `200` `({ name?: string, description?: string, hidden?: number, id?: number, url_alias?: null })[]` OK
             */
            getPubActivityCategory: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/activity/category", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Франшизы
             * @name PostPubFormPublishFranchise
             * @summary Подача заявки на публикацию франшизы
             * @request POST:/pub/form/publish_franchise
             * @secure
             * @response `200` `{ message?: string }` OK
             */
            postPubFormPublishFranchise: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/form/publish_franchise", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Франшизы
             * @name GetPubFranchisesArticlesId
             * @summary Получение статей по франшизе
             * @request GET:/pub/franchises/articles/{id}
             * @secure
             * @response `200` `(Article)[]` OK
             */
            getPubFranchisesArticlesId: function (id, query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/franchises/articles/".concat(id), method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Франшизы
             * @name GetPubSpecialMarks
             * @summary Получение списка значений по полю "Особые отметки"
             * @request GET:/pub/special/marks
             * @secure
             * @response `200` `({ name?: string, description?: string, hidden?: number, id?: number, url_alias?: null })[]` OK
             */
            getPubSpecialMarks: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/special/marks", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Франшизы
             * @name PostPubFormContactFranchiseId
             * @summary Связаться с Франчайзером
             * @request POST:/pub/form/contact_franchise/{id}
             * @secure
             * @response `200` `{ message?: string }` OK
             */
            postPubFormContactFranchiseId: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/form/contact_franchise/".concat(id), method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Иностранные агенты или запрещенные организации
             * @name GetPubUnacceptableId
             * @summary Получение публичной информации по Иностранному агенту или запрещенной организации
             * @request GET:/pub/unacceptable/{id}
             * @secure
             * @response `200` `{ type?: string, name?: string, grounds?: string, info?: { id?: string, inn?: null, ogrn?: null, snils?: null, posted?: null, address?: null, resource?: (string)[], birthdate?: null, reg_number?: null, participants?: (string)[] }, inclusion?: number, fresh?: boolean, exclusion?: null, types?: ({ type?: { slug?: string, name?: string, description?: null, id?: number }, id?: number })[], keys?: ({ name?: string, id?: number })[], id?: number }` OK
             */
            getPubUnacceptableId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/unacceptable/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostPubFormRequestClub
             * @summary Отправка заявки на вступление в ForbesClub
             * @request POST:/pub/form/request_club
             * @secure
             * @response `200` `{ message?: string }` OK
             */
            postPubFormRequestClub: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/form/request_club", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubClubClients
             * @summary Получение всех возможных клиентов
             * @request GET:/pub/club_clients
             * @secure
             * @response `200` `{ name?: string, description?: string, id?: number, url_alias?: string }` OK
             */
            getPubClubClients: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/club_clients", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags ForbesClub
             * @name GetPubEvents
             * @summary Получение списка мероприятий
             * @request GET:/pub/events
             * @secure
             * @response `200` `PubArticle` OK
             */
            getPubEvents: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/events", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags ForbesClub
             * @name GetPubClubDirection
             * @summary Получение списка значений по полю "Направление"
             * @request GET:/pub/club/direction
             * @secure
             * @response `200` `({ name?: string, description?: string, hidden?: number, id?: number, url_alias?: null })[]` OK
             */
            getPubClubDirection: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/club/direction", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPubProfiles
             * @summary Получение профилей
             * @request GET:/pub/profiles
             * @secure
             * @response `200` `List` OK
             */
            getPubProfiles: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/pub/profiles", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
        };
        _this.users = {
            /**
             * No description
             *
             * @name PostPubLinkVk
             * @summary Link VK
             * @request POST:/users/link_vk
             * @secure
             * @response `200` `User` OK
             */
            postPubLinkVk: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/users/link_vk", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostPubLinkGoogle
             * @summary Link Google
             * @request POST:/users/link_google
             * @secure
             * @response `200` `JWT` OK
             * @response `0` `User`
             */
            postPubLinkGoogle: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/users/link_google", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostPubLinkYandex
             * @summary Link Yandex
             * @request POST:/users/link_yandex
             * @secure
             * @response `200` `JWT` OK
             * @response `0` `User`
             */
            postPubLinkYandex: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/users/link_yandex", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostPubLinkMailru
             * @summary Link Mail.ru
             * @request POST:/users/link_mailru
             * @secure
             * @response `200` `JWT` OK
             * @response `0` `User`
             */
            postPubLinkMailru: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/users/link_mailru", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostUsersNewPassword
             * @summary Change password
             * @request POST:/users/new_password
             * @secure
             * @response `200` `User` OK
             * @response `0` `User`
             */
            postUsersNewPassword: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/users/new_password", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * @description List users
             *
             * @tags user
             * @name ListUsers
             * @summary ListUsers
             * @request GET:/users
             * @secure
             * @response `200` `(User)[]` List of users
             */
            listUsers: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/users", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * @description Creates a new user
             *
             * @tags user
             * @name CreateUser
             * @summary CreateUser
             * @request POST:/users
             * @secure
             * @response `201` `User` Created
             * @response `400` `Error` Bad Request
             */
            createUser: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/users", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * @description Current authorized user
             *
             * @tags user
             * @name GetCurrentUser
             * @summary CurrentUser
             * @request GET:/users/me
             * @secure
             * @response `200` `User` OK
             */
            getCurrentUser: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/users/me", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * @description Get user data by id
             *
             * @tags user
             * @name GetUserById
             * @summary GetUserByID
             * @request GET:/users/{id}
             * @secure
             * @response `200` `User` OK
             * @response `404` `Error` Not Found
             */
            getUserById: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/users/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * @description Update user data by id
             *
             * @tags user
             * @name UpdateUserById
             * @summary UpdateUserByID
             * @request PATCH:/users/{id}
             * @secure
             * @response `200` `User` OK
             * @response `400` `Error` Bad Request
             * @response `404` `Error` Not Found
             */
            updateUserById: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/users/".concat(id), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * @description Delete a user by id
             *
             * @tags user
             * @name DeleteUserById
             * @summary DeleteUserByID
             * @request DELETE:/users/{id}
             * @secure
             * @response `204` `void` No Content
             * @response `404` `Error` Not Found
             */
            deleteUserById: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/users/".concat(id), method: 'DELETE', secure: true }, params));
            },
            /**
             * No description
             *
             * @name Subscribe
             * @summary Subscribe
             * @request POST:/users/subscribe
             * @secure
             */
            subscribe: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/users/subscribe", method: 'POST', query: query, secure: true }, params));
            },
            /**
             * No description
             *
             * @name PostUsersUndeleteId
             * @summary Undelete user
             * @request POST:/users/undelete/{id}
             * @secure
             * @response `200` `User` OK
             */
            postUsersUndeleteId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/users/undelete/".concat(id), method: 'POST', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetUsersNewsletters
             * @summary Get user newsletters
             * @request GET:/users/newsletters
             * @secure
             * @response `200` `{ lists?: ({ id?: string, status?: string })[] }` OK
             */
            getUsersNewsletters: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/users/newsletters", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PatchUsersIdBlock
             * @summary Block user
             * @request PATCH:/users/{id}/block
             * @secure
             * @response `200` `User` OK
             */
            patchUsersIdBlock: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/users/".concat(id, "/block"), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PatchUsersIdUnblock
             * @summary Unblock user
             * @request PATCH:/users/{id}/unblock
             * @secure
             * @response `200` `User` OK
             */
            patchUsersIdUnblock: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/users/".concat(id, "/unblock"), method: 'PATCH', secure: true, format: 'json' }, params));
            },
        };
        _this.roles = {
            /**
             * @description Get role data by id
             *
             * @tags role
             * @name GetRoleById
             * @summary GetRoleByID
             * @request GET:/roles/{id}
             * @secure
             * @response `200` `Role` OK
             * @response `404` `Error` Not Found
             */
            getRoleById: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/roles/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * @description Update role data by id
             *
             * @tags role
             * @name UpdateRoleById
             * @summary UpdateRoleByID
             * @request PATCH:/roles/{id}
             * @secure
             * @response `200` `Role` OK
             * @response `400` `Error` Bad Request
             * @response `404` `Error` Not Found
             */
            updateRoleById: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/roles/".concat(id), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * @description Delete a role by id
             *
             * @tags role
             * @name DeleteRoleById
             * @summary DeleteRoleByID
             * @request DELETE:/roles/{id}
             * @secure
             * @response `204` `void` No Content
             * @response `404` `Error` Not Found
             */
            deleteRoleById: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/roles/".concat(id), method: 'DELETE', secure: true }, params));
            },
            /**
             * No description
             *
             * @name PostRolesId
             * @request POST:/roles/{id}
             * @secure
             * @response `200` `{ name?: string, permissions?: ({ id?: string, name?: string })[], slug?: string, id?: number }` OK
             */
            postRolesId: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/roles/".concat(id), method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * @description List roles
             *
             * @tags role
             * @name ListRoles
             * @summary ListRoles
             * @request GET:/roles
             * @secure
             * @response `200` `(Role)[]` OK
             */
            listRoles: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/roles", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * @description Creates a new role
             *
             * @tags role
             * @name CreateRole
             * @summary CreateRole
             * @request POST:/roles
             * @secure
             * @response `201` `Role` Created
             * @response `400` `Error` Bad Request
             */
            createRole: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/roles", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
        };
        _this.permissions = {
            /**
             * @description Get permission data by id
             *
             * @tags permission
             * @name GetPermissionById
             * @summary GetPermissionByID
             * @request GET:/permissions/{id}
             * @secure
             * @response `200` `{ id?: number, permission?: string, name?: string }` OK
             * @response `404` `Error` Not Found
             */
            getPermissionById: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/permissions/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * @description Update permission data by id
             *
             * @tags permission
             * @name UpdatePermissionById
             * @summary UpdatePermissionByID
             * @request PATCH:/permissions/{id}
             * @secure
             * @response `200` `Permission` OK
             * @response `400` `Error` Bad Request
             * @response `404` `Error` Not Found
             */
            updatePermissionById: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/permissions/".concat(id), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * @description Delete a permission by id
             *
             * @tags permission
             * @name DeletePermissionById
             * @summary DeletePermissionByID
             * @request DELETE:/permissions/{id}
             * @secure
             * @response `204` `void` No Content
             * @response `404` `Error` Not Found
             */
            deletePermissionById: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/permissions/".concat(id), method: 'DELETE', secure: true }, params));
            },
            /**
             * @description List permissions
             *
             * @tags permission
             * @name ListPermissions
             * @summary ListPermissions
             * @request GET:/permissions
             * @secure
             * @response `200` `(Permission)[]` OK
             */
            listPermissions: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/permissions", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * @description Creates a new permission
             *
             * @tags permission
             * @name CreatePermission
             * @summary CreatePermission
             * @request POST:/permissions
             * @secure
             * @response `201` `Permission` Created
             * @response `400` `Error` Bad Request
             */
            createPermission: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/permissions", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPermissionsList
             * @summary /permissions/list
             * @request GET:/permissions/list
             * @secure
             * @response `200` `({ id?: number, permission?: string, name?: string })[]` OK
             */
            getPermissionsList: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/permissions/list", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
        };
        _this.articles = {
            /**
             * @description List of articles
             *
             * @tags article
             * @name GetArticles
             * @summary GetArticles
             * @request GET:/articles
             * @secure
             * @response `200` `(Article)[]` OK
             */
            getArticles: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/articles", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * @description Get articles types available for user
             *
             * @tags article
             * @name GetArticlesTypes
             * @summary GetArticlesTypes
             * @request GET:/articles/types
             * @secure
             * @response `200` `(Type)[]` OK
             */
            getArticlesTypes: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/articles/types", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * @description Get articles type fields
             *
             * @tags article
             * @name GetArticleTypeFields
             * @summary GetArticlesTypeFields
             * @request GET:/articles/{type}/fields
             * @secure
             * @response `200` `(Field)[]` OK
             */
            getArticleTypeFields: function (type, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/articles/".concat(type, "/fields"), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * @description Create new article
             *
             * @tags article
             * @name CreateArticle
             * @summary CreateArticle
             * @request POST:/articles/{type}
             * @secure
             * @response `200` `Article` OK
             * @response `400` `Error` Bad Request
             */
            createArticle: function (type, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/articles/".concat(type), method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * @description Update article data
             *
             * @tags article
             * @name UpdateArticle
             * @summary UpdateArticle
             * @request PATCH:/articles/{type}
             * @secure
             * @response `200` `Article` OK
             * @response `400` `Error` Bad Request
             */
            updateArticle: function (type, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/articles/".concat(type), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * @description Publish article
             *
             * @tags article
             * @name PublishArticle
             * @summary PublishArticle
             * @request POST:/articles/{id}/publish
             * @secure
             * @response `200` `Article` OK
             */
            publishArticle: function (id, query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/articles/".concat(id, "/publish"), method: 'POST', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * @description Unpublish article
             *
             * @tags article
             * @name UnpublishArticle
             * @summary UnpublishArticle
             * @request POST:/articles/{id}/delist
             * @secure
             * @response `200` `Article` OK
             */
            unpublishArticle: function (id, query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/articles/".concat(id, "/delist"), method: 'POST', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * @description Get article by ID
             *
             * @name GetArticleById
             * @summary GetArticleByID
             * @request GET:/articles/{id}
             * @secure
             * @response `200` `Article` OK
             */
            getArticleById: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/articles/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name DeleteArticlesId
             * @summary Delete article
             * @request DELETE:/articles/{id}
             * @secure
             * @response `204` `void` No Content
             */
            deleteArticlesId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/articles/".concat(id), method: 'DELETE', secure: true }, params));
            },
            /**
             * No description
             *
             * @name GetArticlesByView
             * @summary Your GET endpoint
             * @request GET:/articles/view/{view}
             * @secure
             * @response `200` `(Article)[]` OK
             */
            getArticlesByView: function (view, query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/articles/view/".concat(view), method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetProfiles
             * @summary GET profiles
             * @request GET:/articles/view/profiles
             * @secure
             * @response `200` `(Article)[]` OK
             */
            getProfiles: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/articles/view/profiles", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * @description Список статусов воронки публикации
             *
             * @name GetApiArticlesPipelineStatuses
             * @summary Your GET endpoint
             * @request GET:/articles/pipeline/statuses
             * @secure
             */
            getApiArticlesPipelineStatuses: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/articles/pipeline/statuses", method: 'GET', body: data, secure: true, type: ContentType.Json }, params));
            },
            /**
             * No description
             *
             * @name GetArticlesSearch
             * @summary Your GET endpoint
             * @request GET:/articles/search
             * @secure
             * @response `200` `(Article)[]` OK
             */
            getArticlesSearch: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/articles/search", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostArticlesPreviewId
             * @request POST:/articles/preview/{id}
             * @secure
             * @response `200` `{ link?: string }` OK
             */
            postArticlesPreviewId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/articles/preview/".concat(id), method: 'POST', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetArticlesViewSections
             * @summary Your GET endpoint
             * @request GET:/articles/view/sections
             * @secure
             * @response `200` `(Article)[]` OK
             */
            getArticlesViewSections: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/articles/view/sections", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetArticlesViewCommercial
             * @summary Your GET endpoint
             * @request GET:/articles/view/commercial
             * @secure
             * @response `200` `(Article)[]` OK
             */
            getArticlesViewCommercial: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/articles/view/commercial", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetArticlesViewEducation
             * @summary Get education articles
             * @request GET:/articles/view/education
             * @secure
             * @response `200` `(Article)[]` OK
             */
            getArticlesViewEducation: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/articles/view/education", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetArticlesViewCompanyNews
             * @summary Get company news articles
             * @request GET:/articles/view/company_news
             * @secure
             * @response `200` `(Article)[]` OK
             */
            getArticlesViewCompanyNews: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/articles/view/company_news", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetArticlesLog
             * @summary Admin logs
             * @request GET:/articles/log
             * @secure
             * @response `200` `(Log)[]` OK
             */
            getArticlesLog: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/articles/log", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetArticlesViewCreators
             * @summary /articles/view/creators
             * @request GET:/articles/view/creators
             * @secure
             * @response `200` `({ id?: number, username?: string, display_name?: string, email?: string, surname?: string })[]` OK
             */
            getArticlesViewCreators: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/articles/view/creators", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Сюжеты Дзен.Новости
             * @name GetArticlesViewYandexNews
             * @summary /articles/view/yandex_news
             * @request GET:/articles/view/yandex_news
             * @secure
             */
            getArticlesViewYandexNews: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/articles/view/yandex_news", method: 'GET', query: query, secure: true }, params));
            },
            /**
             * No description
             *
             * @tags Сюжеты Дзен.Новости
             * @name GetArticlesViewDzenNews
             * @summary Получение списка материалов, которые попали в сюжет
             * @request GET:/articles/view/dzen/news
             * @secure
             * @response `200` `{ id?: number, rubric?: string, title?: string, text?: string, source_name?: string, logs?: { last?: { title?: string, time?: string, image?: string, sourceName?: string, url?: string, vector?: number, diff?: string, position?: number }, previous?: { title?: string, time?: string, image?: string, sourceName?: string, url?: string, vector?: number, diff?: string, position?: number } } }` OK
             */
            getArticlesViewDzenNews: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/articles/view/dzen/news", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Иностранные агенты или запрещенные организации
             * @name PostArticlesScanner
             * @summary Поинт для сканирования текста на предмет содержащих информацию о иностранных агентах или запрещенных организациях
             * @request POST:/articles/scanner
             * @secure
             * @response `200` `({ type?: string, name?: string, grounds?: string, info?: { id?: string, inn?: null, ogrn?: null, snils?: null, posted?: null, address?: null, resource?: (string)[], birthdate?: null, reg_number?: null, participants?: (string)[] }, inclusion?: number, fresh?: boolean, exclusion?: null, types?: ({ type?: { slug?: string, name?: string, description?: null, id?: number }, id?: number })[], keys?: ({ name?: string, id?: number })[], id?: number })[]` OK
             */
            postArticlesScanner: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/articles/scanner", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
        };
        _this.types = {
            /**
             * @description Get all articles types
             *
             * @tags article
             * @name GetAllArticlesTypes
             * @summary GetAllArticlesTypes
             * @request GET:/types
             * @secure
             * @response `200` `(Type)[]` OK
             */
            getAllArticlesTypes: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/types", method: 'GET', secure: true, format: 'json' }, params));
            },
        };
        _this.lists = {
            /**
             * @description List of Lists
             *
             * @tags list
             * @name GetLists
             * @summary GetLists
             * @request GET:/lists
             * @secure
             * @response `200` `(List)[]` OK
             */
            getLists: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/lists", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * @description Creates a new list
             *
             * @tags list
             * @name CreateList
             * @summary CreateList
             * @request POST:/lists
             * @secure
             * @response `201` `List` Created
             */
            createList: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/lists", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * @description Get list data by id or slug
             *
             * @tags list
             * @name GetListById
             * @summary GetListByID
             * @request GET:/lists/{id}
             * @secure
             * @response `200` `ListWithArticles` OK
             * @response `404` `Error` Not Found
             */
            getListById: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/lists/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * @description Update list data by id or slug
             *
             * @tags list
             * @name UpdateListById
             * @summary UpdateListByID
             * @request PATCH:/lists/{id}
             * @secure
             * @response `200` `List` OK
             * @response `400` `Error` Bad Request
             * @response `404` `Error` Not Found
             */
            updateListById: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/lists/".concat(id), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * @description Delete a list by id or slug
             *
             * @tags list
             * @name DeleteListById
             * @summary DeleteListByID
             * @request DELETE:/lists/{id}
             * @secure
             * @response `204` `void` No Content
             * @response `404` `Error` Not Found
             */
            deleteListById: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/lists/".concat(id), method: 'DELETE', secure: true }, params));
            },
            /**
             * @description Replaces list articles
             *
             * @tags list
             * @name PutListArticles
             * @summary PutListArticles
             * @request PUT:/lists/{id}/articles
             * @secure
             * @response `200` `List` OK
             * @response `400` `Error` Bad Request
             * @response `404` `Error` Not Found
             */
            putListArticles: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/lists/".concat(id, "/articles"), method: 'PUT', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
        };
        _this.files = {
            /**
             * @description Upload a file
             *
             * @tags file
             * @name UploadFile
             * @summary UploadFile
             * @request POST:/files
             * @secure
             * @response `200` `File` OK
             */
            uploadFile: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/files", method: 'POST', body: data, secure: true, type: ContentType.FormData, format: 'json' }, params));
            },
        };
        _this.taxonomyTermData = {
            /**
             * No description
             *
             * @name GetTaxonomyTermDataByVocabulary
             * @summary Your GET endpoint
             * @request GET:/taxonomy_term_data/vocab/{vocabulary}
             * @secure
             * @response `200` `(TaxonomyData)[]` OK
             */
            getTaxonomyTermDataByVocabulary: function (vocabulary, query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/taxonomy_term_data/vocab/".concat(vocabulary), method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostTaxonomyTermData
             * @summary CreateTaxonomyTerm
             * @request POST:/taxonomy_term_data
             * @secure
             * @response `201` `TaxonomyTerm` Created
             */
            postTaxonomyTermData: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/taxonomy_term_data", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetTaxonomyTermData
             * @summary GetTaxonomyTerms
             * @request GET:/taxonomy_term_data
             * @secure
             * @response `200` `(TaxonomyTerm)[]` OK
             */
            getTaxonomyTermData: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/taxonomy_term_data", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetTaxonomyTermDataId
             * @summary GetTaxonomyTerm
             * @request GET:/taxonomy_term_data/{id}
             * @secure
             * @response `200` `TaxonomyTerm` OK
             * @response `404` `Error` Not Found
             */
            getTaxonomyTermDataId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/taxonomy_term_data/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PatchTaxonomyTermDataId
             * @summary UpdateTaxonomyTerm
             * @request PATCH:/taxonomy_term_data/{id}
             * @secure
             * @response `200` `TaxonomyTerm` OK
             * @response `400` `Error` Bad Request
             * @response `404` `Error` Not Found
             */
            patchTaxonomyTermDataId: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/taxonomy_term_data/".concat(id), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name DeleteTaxonomyTermDataId
             * @summary DeleteTaxonomyTerm
             * @request DELETE:/taxonomy_term_data/{id}
             * @secure
             * @response `204` `void` No Content
             * @response `404` `any` Not Found
             */
            deleteTaxonomyTermDataId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/taxonomy_term_data/".concat(id), method: 'DELETE', secure: true }, params));
            },
        };
        _this.ratings = {
            /**
             * @description List of ratings
             *
             * @name GetRatings
             * @summary Get ratings
             * @request GET:/ratings
             * @secure
             * @response `200` `(Rating)[]` OK
             */
            getRatings: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/ratings", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * @description Creates a new rating
             *
             * @name CreateRating
             * @summary CreateRating
             * @request POST:/ratings
             * @secure
             * @response `200` `RatingType` OK
             */
            createRating: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/ratings", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * @description Get ratings types
             *
             * @name GetRatingsTypes
             * @summary getRatingTypes
             * @request GET:/ratings/types
             * @secure
             * @response `200` `(RatingType)[]` OK
             */
            getRatingsTypes: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/ratings/types", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * @description Get profile types
             *
             * @name GetProfileTypes
             * @summary getProfileTypes
             * @request GET:/ratings/profile_types
             * @secure
             * @response `200` `(string)[]` OK
             */
            getProfileTypes: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/ratings/profile_types", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * @description Get rating by ID
             *
             * @name GetRatingById
             * @summary GetRatingByID
             * @request GET:/ratings/{id}
             * @secure
             * @response `200` `Rating` OK
             */
            getRatingById: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/ratings/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * @description Update rating data by id
             *
             * @name UpdateRatingById
             * @summary UpdateRatingByID
             * @request PATCH:/ratings/{id}
             * @secure
             * @response `200` `Rating` OK
             */
            updateRatingById: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/ratings/".concat(id), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name DeleteRatingsId
             * @summary DeleteRatingByID
             * @request DELETE:/ratings/{id}
             * @secure
             * @response `204` `void` No Content
             */
            deleteRatingsId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/ratings/".concat(id), method: 'DELETE', secure: true }, params));
            },
            /**
             * @description Copy rating
             *
             * @name CopyRating
             * @summary CopyRating
             * @request POST:/ratings/{id}/copy
             * @secure
             * @response `200` `Rating` OK
             */
            copyRating: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/ratings/".concat(id, "/copy"), method: 'POST', secure: true, format: 'json' }, params));
            },
            /**
             * @description Get rating fields list by id
             *
             * @name GetRatingFieldsList
             * @summary RatingFieldsList
             * @request GET:/ratings/{id}/fields
             * @secure
             * @response `200` `(RatingField)[]` OK
             */
            getRatingFieldsList: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/ratings/".concat(id, "/fields"), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetRatingFieldValues
             * @summary GetRatingFieldValues
             * @request GET:/ratings/{id}/field_values
             * @secure
             * @response `200` `(RatingFieldValue)[]` OK
             */
            getRatingFieldValues: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/ratings/".concat(id, "/field_values"), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * @description Add profile to rating
             *
             * @name AddRatingProfile
             * @summary AddRatingProfile
             * @request POST:/ratings/{id}/profiles
             * @secure
             * @response `200` `({ val_id?: number, cf_id?: number, pr_id?: number })[]` OK
             */
            addRatingProfile: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/ratings/".concat(id, "/profiles"), method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * @description Delete profile from rating
             *
             * @name DeleteRatingProfile
             * @summary DeleteRatingProfile
             * @request DELETE:/ratings/{id}/profiles
             * @secure
             * @response `204` `void` No Content
             */
            deleteRatingProfile: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/ratings/".concat(id, "/profiles"), method: 'DELETE', body: data, secure: true, type: ContentType.Json }, params));
            },
            /**
             * @description Update field values of rating
             *
             * @name UpdateRatingFieldValues
             * @summary UpdateRatingFieldValues
             * @request POST:/ratings/update_field_values
             * @secure
             * @response `204` `void` No Content
             */
            updateRatingFieldValues: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/ratings/update_field_values", method: 'POST', body: data, secure: true, type: ContentType.Json }, params));
            },
            /**
             * No description
             *
             * @name GetRatingsFields
             * @summary GetRatingsFields
             * @request GET:/ratings/fields
             * @secure
             * @response `200` `(RatingField)[]` OK
             */
            getRatingsFields: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/ratings/fields", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostRatingsField
             * @summary Create rating field
             * @request POST:/ratings/field
             * @secure
             * @response `200` `RatingField` OK
             */
            postRatingsField: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/ratings/field", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetRatingsFieldId
             * @summary Get rating field
             * @request GET:/ratings/field/{id}
             * @secure
             * @response `200` `RatingField` OK
             */
            getRatingsFieldId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/ratings/field/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PatchRatingsFieldId
             * @summary Update rating field
             * @request PATCH:/ratings/field/{id}
             * @secure
             * @response `200` `RatingField` OK
             */
            patchRatingsFieldId: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/ratings/field/".concat(id), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * @description List of sport ratings
             *
             * @name GetRatingsSport
             * @summary Get sport ratings
             * @request GET:/ratings/sport
             * @secure
             * @response `200` `(Rating)[]` OK
             */
            getRatingsSport: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/ratings/sport", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
        };
        _this.hots = {
            /**
             * @description List of hots
             *
             * @name GetHots
             * @summary GetHots
             * @request GET:/hots
             * @secure
             * @response `200` `(Hot)[]` OK
             */
            getHots: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/hots", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * @description Creates a new hot
             *
             * @name CreateHot
             * @summary CreateHot
             * @request POST:/hots
             * @secure
             * @response `201` `Hot` Created
             */
            createHot: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/hots", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * @description Get hot by ID
             *
             * @name GetHotById
             * @summary GetHotByID
             * @request GET:/hots/{id}
             * @secure
             * @response `200` `Hot` OK
             */
            getHotById: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/hots/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * @description Update hot data by id
             *
             * @name UpdateHotById
             * @summary UpdateHotByID
             * @request PATCH:/hots/{id}
             * @secure
             * @response `200` `Hot` OK
             */
            updateHotById: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/hots/".concat(id), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * @description Delete hot by id
             *
             * @name DeleteHotById
             * @summary DeleteHotByID
             * @request DELETE:/hots/{id}
             * @secure
             * @response `204` `void` No Content
             */
            deleteHotById: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/hots/".concat(id), method: 'DELETE', secure: true }, params));
            },
            /**
             * @description List of hot articles
             *
             * @name GetHotArticles
             * @summary GetHotArticles
             * @request GET:/hots/{id}/articles
             * @secure
             * @response `200` `(Article)[]` OK
             */
            getHotArticles: function (id, query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/hots/".concat(id, "/articles"), method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
        };
        _this.taxonomyVocabularies = {
            /**
             * No description
             *
             * @name GetApiTaxonomyVocabularies
             * @summary GetTaxonomyVocabularies
             * @request GET:/taxonomy_vocabularies
             * @secure
             * @response `200` `(TaxonomyVocabulary)[]` OK
             * @response `0` `(TaxonomyVocabulary)[]`
             */
            getApiTaxonomyVocabularies: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/taxonomy_vocabularies", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetTaxonomyVocabulariesTypeFields
             * @summary GetTaxonomyVocabularyFields
             * @request GET:/taxonomy_vocabularies/{type}/fields
             * @secure
             * @response `200` `(Field)[]` OK
             */
            getTaxonomyVocabulariesTypeFields: function (type, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/taxonomy_vocabularies/".concat(type, "/fields"), method: 'GET', secure: true, format: 'json' }, params));
            },
        };
        _this.invoices = {
            /**
             * No description
             *
             * @name PostInvoices
             * @summary Create invoice
             * @request POST:/invoices
             * @secure
             * @response `200` `Invoice` OK
             */
            postInvoices: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/invoices", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
        };
        _this.paywall = {
            /**
             * No description
             *
             * @name GetPaywallArticleId
             * @summary Get paywall article
             * @request GET:/paywall/article/{id}
             * @secure
             * @response `200` `PubArticle` OK
             */
            getPaywallArticleId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/article/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostPaywallSubscriptionsCancel
             * @summary Cancel subscription
             * @request POST:/paywall/subscriptions/cancel
             * @secure
             * @response `200` `PaywallUserPackage` OK
             */
            postPaywallSubscriptionsCancel: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/subscriptions/cancel", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostPaywallSubscriptionsCreate
             * @summary Create subscription
             * @request POST:/paywall/subscriptions/create
             * @secure
             * @response `200` `PaywallUserPackage` OK
             */
            postPaywallSubscriptionsCreate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/subscriptions/create", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPackagesId
             * @summary Get package
             * @request GET:/paywall/packages/{id}
             * @secure
             * @response `200` `PaywallPackage` OK
             */
            getPackagesId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/packages/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PatchPackagesId
             * @summary Patch package
             * @request PATCH:/paywall/packages/{id}
             * @secure
             * @response `200` `PaywallPackage` OK
             */
            patchPackagesId: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/packages/".concat(id), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name DeletePackagesId
             * @request DELETE:/paywall/packages/{id}
             * @secure
             * @response `204` `void` No Content
             */
            deletePackagesId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/packages/".concat(id), method: 'DELETE', secure: true }, params));
            },
            /**
             * No description
             *
             * @name PostPaywallPackagesIdAddGroup
             * @summary Add object group to package
             * @request POST:/paywall/packages/{id}/add_group
             * @secure
             * @response `200` `PaywallPackage` OK
             */
            postPaywallPackagesIdAddGroup: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/packages/".concat(id, "/add_group"), method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostPaywallPackagesIdRemoveGroup
             * @summary Remove object group from package
             * @request POST:/paywall/packages/{id}/remove_group
             * @secure
             * @response `200` `PaywallPackage` OK
             */
            postPaywallPackagesIdRemoveGroup: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/packages/".concat(id, "/remove_group"), method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostPackages
             * @summary Create package
             * @request POST:/paywall/packages
             * @secure
             * @response `200` `PaywallPackage` OK
             */
            postPackages: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/packages", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPaywallPackages
             * @summary Get paywall packages for logined user
             * @request GET:/paywall/packages
             * @secure
             * @response `200` `(PaywallPackage)[]` OK
             */
            getPaywallPackages: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/packages", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostPackagePrices
             * @summary Create package price
             * @request POST:/paywall/package_prices
             * @secure
             * @response `200` `PaywallPackagePrice` OK
             */
            postPackagePrices: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/package_prices", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name DeletePackagePricesId
             * @summary Delete package price
             * @request DELETE:/paywall/package_prices/{id}
             * @secure
             * @response `204` `void` No Content
             */
            deletePackagePricesId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/package_prices/".concat(id), method: 'DELETE', secure: true }, params));
            },
            /**
             * No description
             *
             * @name GetObjectGroups
             * @summary Get object groups
             * @request GET:/paywall/object_groups
             * @secure
             * @response `200` `(PaywallObjectGroup)[]` OK
             */
            getObjectGroups: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/object_groups", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostObjectGroups
             * @summary Create object group
             * @request POST:/paywall/object_groups
             * @secure
             * @response `200` `PaywallObjectGroup` OK
             */
            postObjectGroups: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/object_groups", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetObjectGroupsId
             * @summary Get object group
             * @request GET:/paywall/object_groups/{id}
             * @secure
             * @response `200` `PaywallObjectGroup` OK
             */
            getObjectGroupsId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/object_groups/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PatchObjectGroupsId
             * @summary Patch object group
             * @request PATCH:/paywall/object_groups/{id}
             * @secure
             * @response `200` `PaywallObjectGroup` OK
             */
            patchObjectGroupsId: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/object_groups/".concat(id), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name DeleteObjectGroupsId
             * @summary Delete object group
             * @request DELETE:/paywall/object_groups/{id}
             * @secure
             * @response `204` `void` No Content
             */
            deleteObjectGroupsId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/object_groups/".concat(id), method: 'DELETE', secure: true }, params));
            },
            /**
             * No description
             *
             * @name GetPaywallObjectsTypes
             * @summary Get paywall object types
             * @request GET:/paywall/objects/types
             * @secure
             * @response `200` `({ type?: string, name?: string, description?: string })[]` OK
             */
            getPaywallObjectsTypes: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/objects/types", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostPaywallObjects
             * @summary Create paywall object
             * @request POST:/paywall/objects
             * @secure
             * @response `200` `PaywallObject` OK
             */
            postPaywallObjects: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/objects", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PatchPaywallObjectsId
             * @summary Patch paywall object
             * @request PATCH:/paywall/objects/{id}
             * @secure
             * @response `200` `PaywallObject` OK
             */
            patchPaywallObjectsId: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/objects/".concat(id), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name DeletePaywallObjectsId
             * @summary Delete paywall object
             * @request DELETE:/paywall/objects/{id}
             * @secure
             * @response `204` `void` No Content
             */
            deletePaywallObjectsId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/objects/".concat(id), method: 'DELETE', secure: true }, params));
            },
            /**
             * No description
             *
             * @name GetPaywallUserPackages
             * @summary Get active paywall user packages
             * @request GET:/paywall/user_packages
             * @secure
             * @response `200` `(PaywallUserPackage)[]` OK
             */
            getPaywallUserPackages: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/user_packages", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostPaywallPromoactions
             * @summary Create promoaction
             * @request POST:/paywall/promoactions
             * @secure
             * @response `200` `PaywallPromoaction` OK
             */
            postPaywallPromoactions: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/promoactions", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PatchPaywallPromoactionsId
             * @summary Patch promoaction
             * @request PATCH:/paywall/promoactions/{id}
             * @secure
             * @response `200` `PaywallPromoaction` OK
             */
            patchPaywallPromoactionsId: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/promoactions/".concat(id), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name DeletePaywallPromoactionsId
             * @summary Delete promoaction
             * @request DELETE:/paywall/promoactions/{id}
             * @secure
             * @response `204` `void` No Content
             */
            deletePaywallPromoactionsId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/promoactions/".concat(id), method: 'DELETE', secure: true }, params));
            },
            /**
             * No description
             *
             * @name GetPaywallPromoactionsId
             * @summary Get promoaction
             * @request GET:/paywall/promoactions/{id}
             * @secure
             * @response `200` `PaywallPromoaction` OK
             */
            getPaywallPromoactionsId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/promoactions/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostPaywallPromocodes
             * @summary Create promocode
             * @request POST:/paywall/promocodes
             * @secure
             * @response `200` `PaywallPromocode` OK
             */
            postPaywallPromocodes: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/promocodes", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPaywallPromocodes
             * @summary Get promocodes list
             * @request GET:/paywall/promocodes
             * @secure
             * @response `200` `({ value?: string, start?: number, end?: number, count?: number, id?: number, promoaction?: PaywallPromoaction, activationCount?: number })[]` OK
             */
            getPaywallPromocodes: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/promocodes", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPaywallPromocodesId
             * @summary Get promocode
             * @request GET:/paywall/promocodes/{id}
             * @secure
             * @response `200` `PaywallPromocode` OK
             */
            getPaywallPromocodesId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/promocodes/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PatchPaywallPromocodesId
             * @summary Patch promocode
             * @request PATCH:/paywall/promocodes/{id}
             * @secure
             * @response `200` `PaywallPromocode` OK
             */
            patchPaywallPromocodesId: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/promocodes/".concat(id), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPaywallPromocodesGenerate
             * @summary Get generated promo code
             * @request GET:/paywall/promocodes/generate
             * @secure
             * @response `200` `{ promocode?: string }` OK
             */
            getPaywallPromocodesGenerate: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/promocodes/generate", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostPaywallPromocodesActivate
             * @summary Activate promocode
             * @request POST:/paywall/promocodes/activate
             * @secure
             * @response `200` `PaywallPromoaction` OK
             */
            postPaywallPromocodesActivate: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/promocodes/activate", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetPaywallPackagesList
             * @summary Get paywall packages
             * @request GET:/paywall/packages/list
             * @secure
             * @response `200` `(PaywallPackage)[]` OK
             */
            getPaywallPackagesList: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/paywall/packages/list", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
        };
        _this.transactions = {
            /**
             * No description
             *
             * @name GetTransactions
             * @summary Get transactions
             * @request GET:/transactions
             * @secure
             * @response `200` `(Transaction)[]` OK
             */
            getTransactions: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/transactions", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
        };
        _this.reports = {
            /**
             * No description
             *
             * @name CreateReportsAuthors
             * @summary Reports list
             * @request GET:/reports
             * @secure
             * @response `200` `(Report)[]` OK
             */
            createReportsAuthors: function (data, query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/reports", method: 'GET', query: query, body: data, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name DeleteReportsId
             * @summary Delete report
             * @request DELETE:/reports/{id}
             * @secure
             * @response `204` `void` No Content
             */
            deleteReportsId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/reports/".concat(id), method: 'DELETE', secure: true }, params));
            },
            /**
             * No description
             *
             * @name CreateAuthorsReport
             * @summary Create authors report
             * @request POST:/reports/authors
             * @secure
             * @response `200` `Report` OK
             */
            createAuthorsReport: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/reports/authors", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name CreateTranslatorsReport
             * @summary Create translators report
             * @request POST:/reports/translators
             * @secure
             * @response `200` `Report` OK
             */
            createTranslatorsReport: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/reports/translators", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostReportsMetrikaMonth
             * @summary Create report metrika month
             * @request POST:/reports/metrika/month
             * @secure
             * @response `200` `Report` OK
             */
            postReportsMetrikaMonth: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/reports/metrika/month", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostReportsMetrikaWeek
             * @summary Create report metrika week
             * @request POST:/reports/metrika/week
             * @secure
             * @response `200` `Report` OK
             */
            postReportsMetrikaWeek: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/reports/metrika/week", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
        };
        _this.savedArticle = {
            /**
             * No description
             *
             * @name PostSaveArticle
             * @summary Add article to favorites
             * @request POST:/saved_article
             * @secure
             * @response `200` `SavedArticle` OK
             */
            postSaveArticle: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/saved_article", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name DeleteSaveArticle
             * @summary Remove article from favorites
             * @request DELETE:/saved_article
             * @secure
             * @response `204` `void` No Content
             */
            deleteSaveArticle: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/saved_article", method: 'DELETE', body: data, secure: true, type: ContentType.Json }, params));
            },
            /**
             * No description
             *
             * @name GetSavedArticle
             * @request GET:/saved_article
             * @secure
             * @response `200` `SavedArticle` OK
             */
            getSavedArticle: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/saved_article", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
        };
        _this.savedArticles = {
            /**
             * No description
             *
             * @name GetSavedArticles
             * @summary Get user favorite articles
             * @request GET:/saved_articles
             * @secure
             * @response `200` `(SavedArticle)[]` OK
             */
            getSavedArticles: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/saved_articles", method: 'GET', secure: true, format: 'json' }, params));
            },
        };
        _this.reportsId = {
            /**
             * No description
             *
             * @name DeleteReportsId
             * @request DELETE:/reports{id}
             * @secure
             * @response `200` `void` OK
             */
            deleteReportsId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/reports".concat(id), method: 'DELETE', secure: true }, params));
            },
        };
        _this.polls = {
            /**
             * @description Список опросов
             *
             * @tags Опросы\Тесты\Голосования
             * @name GetPollsList
             * @summary Получение списка по опросам
             * @request GET:/polls
             * @secure
             * @response `200` `Polls` OK
             */
            getPollsList: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/polls", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * @description Создание опроса
             *
             * @tags Опросы\Тесты\Голосования
             * @name PostPolls
             * @summary Создание опроса
             * @request POST:/polls
             * @secure
             * @response `200` `Polls` OK
             */
            postPolls: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/polls", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * @description Получение самого опроса по индентификатору
             *
             * @tags Опросы\Тесты\Голосования
             * @name GetPollsId
             * @summary Получить информацию по опросу
             * @request GET:/polls/{id}
             * @secure
             * @response `200` `Polls` OK
             */
            getPollsId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/polls/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * @description Обновление опроса по индентификатору
             *
             * @tags Опросы\Тесты\Голосования
             * @name PatchPollsId
             * @summary Обновить информацию по опросу
             * @request PATCH:/polls/{id}
             * @secure
             * @response `200` `Polls` OK
             */
            patchPollsId: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/polls/".concat(id), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * @description Удаление опроса по индентификатору
             *
             * @tags Опросы\Тесты\Голосования
             * @name DeletePollsId
             * @summary Удалить всю информацию по опросу
             * @request DELETE:/polls/{id}
             * @secure
             * @response `200` `void` OK
             */
            deletePollsId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/polls/".concat(id), method: 'DELETE', secure: true }, params));
            },
            /**
             * @description Поинт для публикации опроса
             *
             * @tags Опросы\Тесты\Голосования
             * @name PostPollsIdPublish
             * @summary Опубликовать опрос
             * @request POST:/polls/{id}/publish
             * @secure
             * @response `200` `Polls` OK
             */
            postPollsIdPublish: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/polls/".concat(id, "/publish"), method: 'POST', body: data, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Опросы\Тесты\Голосования
             * @name PostPollsIdDelist
             * @summary Снять с публикации опрос
             * @request POST:/polls/{id}/delist
             * @secure
             * @response `200` `Polls` OK
             */
            postPollsIdDelist: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/polls/".concat(id, "/delist"), method: 'POST', secure: true, format: 'json' }, params));
            },
            /**
             * @description Поинт для прохождеения самого опроса по индентификатору
             *
             * @tags Опросы\Тесты\Голосования
             * @name PostPollsIdPass
             * @summary Ответить на опрос
             * @request POST:/polls/{id}/answer
             * @secure
             * @response `200` `{ title?: string, description?: null, type?: null, correct?: number, results?: { start_range?: number, end_range?: number, body?: (object)[], id?: number }, questions?: ({ body?: (object)[], answers?: ({ body?: (object)[], description?: (object)[], weight?: number, correct?: boolean, id?: number, count_answers?: number })[], id?: number })[] }` OK
             */
            postPollsIdPass: function (data, id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/polls/".concat(id, "/answer"), method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
        };
        _this.generate = {
            /**
             * @description Для выбора конкретной нейросети необходимо в slug передать yandex_gpt/chat_gpt.
             *
             * @tags Генерация заголовка
             * @name PostGenerateTitle
             * @summary Генератор заголовков по указанному описанию
             * @request POST:/generate/title
             * @secure
             * @response `200` `{ node_id?: number, slug?: string, title?: string, id?: number }` OK
             */
            postGenerateTitle: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/generate/title", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Генерация заголовка
             * @name GetGenerateTitle
             * @summary Получение списка сгенерированных заголовков
             * @request GET:/generate/title
             * @secure
             * @response `200` `({ node_id?: number, slug?: string, title?: string, id?: number })[]` OK
             */
            getGenerateTitle: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/generate/title", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Генерация заголовка
             * @name DeleteChatgptNodeTitles
             * @summary Удаление сгенерированного заголовка
             * @request DELETE:/generate/title/{id}
             * @secure
             * @response `200` `{ message?: string }` OK
             */
            deleteChatgptNodeTitles: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/generate/title/".concat(id), method: 'DELETE', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostGenerateRetelling
             * @summary Генератор краткого пересказа по указанному описанию
             * @request POST:/generate/retelling
             * @secure
             * @response `200` `{ retelling?: string }` OK
             */
            postGenerateRetelling: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/generate/retelling", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
        };
        _this.yandexNews = {
            /**
             * @description Получение списку сюжетов
             *
             * @tags Сюжеты Дзен.Новости
             * @name GetYandexNews
             * @summary /yandex_news
             * @request GET:/yandex_news
             * @secure
             * @response `200` `{ link?: string, name_source?: string, title_source?: string, link_source?: string, section_media?: ({ type?: string, id?: string, original?: { src?: string }, preview?: { type?: string, src?: string }, source?: { name?: string, url?: string, logo?: { src?: string } }, size?: { width?: number, height?: number } })[], section_source?: { last?: { agency?: string, position?: number, link?: string, title?: string, time?: string, quoted?: boolean, vector?: string, diff?: string }, previous?: { agency?: string, position?: number, link?: string, title?: string, time?: string, quoted?: boolean, vector?: string, diff?: string } }, created?: number, updated?: number, link_with_parameters?: string, node_id?: number, id?: number, rubric?: string, total_source?: (object)[] }` OK
             */
            getYandexNews: function (data, query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/yandex_news", method: 'GET', query: query, body: data, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Сюжеты Дзен.Новости
             * @name GetYandexNewsId
             * @summary /yandex_news/{id}
             * @request GET:/yandex_news/{id}
             * @secure
             * @response `200` `{ link?: string, name_source?: string, title_source?: string, link_source?: string, section_media?: ({ type?: string, id?: string, original?: { src?: string }, preview?: { type?: string, src?: string }, source?: { name?: string, url?: string, logo?: { src?: string } }, size?: { width?: number, height?: number } })[], section_source?: ({ agency?: string, position?: number, link?: string, title?: string, time?: string, quoted?: boolean, vector?: string, diff?: string })[], created?: number, updated?: number, link_with_parameters?: string, node_id?: number, id?: number, rubric?: string, total_source?: (object)[], logs?: ({ section_media?: null, section_source?: ({ agency?: string, position?: number, link?: string, title?: string, time?: string, quoted?: boolean, vector?: string, diff?: string })[] })[] }` OK
             */
            getYandexNewsId: function (id, query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/yandex_news/".concat(id), method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
        };
        _this.cache = {
            /**
             * No description
             *
             * @name DeleteCacheClear
             * @summary Сброс cache
             * @request DELETE:/cache/clear
             * @secure
             * @response `200` `{ success?: boolean, message?: string }` OK
             */
            deleteCacheClear: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/cache/clear", method: 'DELETE', secure: true, format: 'json' }, params));
            },
        };
        _this.taxonomy = {
            /**
             * No description
             *
             * @name GetTaxonomySectionsHierarchy
             * @summary Get sections hierarchy
             * @request GET:/taxonomy/sections_hierarchy
             * @secure
             * @response `200` `(TaxonomyTerm)[]` OK
             */
            getTaxonomySectionsHierarchy: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/taxonomy/sections_hierarchy", method: 'GET', secure: true, format: 'json' }, params));
            },
        };
        _this.menus = {
            /**
             * @description Создание нового меню
             *
             * @tags Меню
             * @name PostMenus
             * @summary Создание нового меню
             * @request POST:/menus
             * @secure
             * @response `200` `Menu` OK
             */
            postMenus: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/menus", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * @description Получение списка созданых меню
             *
             * @tags Меню
             * @name GetMenusList
             * @summary Получение списка созданных меню
             * @request GET:/menus/list
             * @secure
             * @response `200` `(Menu)[]` OK
             */
            getMenusList: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/menus/list", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Меню
             * @name GetMenusId
             * @summary Получение информации по меню
             * @request GET:/menus/{id}
             * @secure
             * @response `200` `Menu` OK
             * @response `400` `{ message?: string }` Bad Request
             */
            getMenusId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/menus/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Меню
             * @name PatchMenusId
             * @summary Обновление информации по меню
             * @request PATCH:/menus/{id}
             * @secure
             * @response `200` `Menu` OK
             * @response `400` `{ message?: string }` Bad Request
             */
            patchMenusId: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/menus/".concat(id), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Меню
             * @name DeleteMenusId
             * @summary Удаление меню и связанной информации
             * @request DELETE:/menus/{id}
             * @secure
             * @response `200` `{ message?: string }` OK
             * @response `400` `{ message?: string }` Bad Request
             */
            deleteMenusId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/menus/".concat(id), method: 'DELETE', secure: true, format: 'json' }, params));
            },
        };
        _this.unisender = {
            /**
             * @description Данный метод используется для получения списка всех шаблонов, созданных как через личный кабинет Unisender, так и через API.
             *
             * @tags Автоматизация рассылок
             * @name GetUnisenderTemplates
             * @summary Метод для получения списка всех шаблонов
             * @request GET:/unisender/templates
             * @secure
             * @response `200` `({ id?: number, sub_user_login?: string, title?: string, description?: string, lang_code?: string, subject?: string, attachments?: string, screenshot_url?: string, created?: string, updated?: string, message_format?: string, type?: string, fullsize_screenshot_url?: string })[]` OK
             * @response `403` `{ message?: string }` Forbidden
             */
            getUnisenderTemplates: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/unisender/templates", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Автоматизация рассылок
             * @name PostUnisenderTemplates
             * @summary Метод для создания шаблона email письма для массовой рассылки
             * @request POST:/unisender/templates
             * @secure
             * @response `200` `{ template_id?: number }` OK
             * @response `403` `{ message?: string }` Forbidden
             */
            postUnisenderTemplates: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/unisender/templates", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Автоматизация рассылок
             * @name GetUnisenderMessages
             * @summary Метод для получения списка всех сообщений
             * @request GET:/unisender/messages
             * @secure
             * @response `200` `({ id?: number, login?: string, sub_user_login?: string, list_id?: number, segment_id?: null, lang_code?: string, created?: string, updated?: string, service_type?: string, message_format?: string, sender_email?: string, sender_name?: string, subject?: string })[]` OK
             */
            getUnisenderMessages: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/unisender/messages", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Автоматизация рассылок
             * @name PostUnisenderMessages
             * @summary Метод для создания e-mail сообщения (без отправки)
             * @request POST:/unisender/messages
             * @secure
             * @response `200` `{ message_id?: number }` OK
             */
            postUnisenderMessages: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/unisender/messages", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Автоматизация рассылок
             * @name GetUnisenderMessagesId
             * @summary Метод для получения информации об SMS или email сообщении
             * @request GET:/unisender/messages/{message_id}
             * @secure
             * @response `200` `({ id?: string, sub_user_login?: null, list_id?: string, created?: string, last_update?: string, service_type?: string, lang_code?: string, active_version_id?: null, message_format?: string, wrap_type?: string, images_behavior?: string, sender_email?: string, sender_name?: string, subject?: string, body?: string, text_body?: string })[]` OK
             */
            getUnisenderMessagesId: function (messageId, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/unisender/messages/".concat(messageId), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Автоматизация рассылок
             * @name DeleteUnisenderMessagesId
             * @summary Метод для удаления сообщения
             * @request DELETE:/unisender/messages/{message_id}
             * @secure
             * @response `200` `object` OK
             */
            deleteUnisenderMessagesId: function (messageId, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/unisender/messages/".concat(messageId), method: 'DELETE', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Автоматизация рассылок
             * @name PatchUnisenderMessagesMessageId
             * @summary Метод для редактирования существующего email сообщения
             * @request PATCH:/unisender/messages/{message_id}
             * @secure
             * @response `200` `{ message_id?: number }` OK
             */
            patchUnisenderMessagesMessageId: function (messageId, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/unisender/messages/".concat(messageId), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Автоматизация рассылок
             * @name GetUnisenderLists
             * @summary Метод для получения перечня всех имеющихся списков рассылок
             * @request GET:/unisender/lists
             * @secure
             * @response `200` `({ id?: number, title?: string })[]` OK
             */
            getUnisenderLists: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/unisender/lists", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Автоматизация рассылок
             * @name GetUnisenderTags
             * @summary Метод для получения пользовательских меток
             * @request GET:/unisender/tags
             * @secure
             * @response `200` `({ id?: number, name?: string })[]` OK
             */
            getUnisenderTags: function (params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/unisender/tags", method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Автоматизация рассылок
             * @name PostUnisenderCampaignsMessageId
             * @summary Запланировать или начать немедленно рассылку e-mail или SMS-сообщения
             * @request POST:/unisender/campaigns/{message_id}
             * @secure
             * @response `200` `{ campaign_id?: number, status?: string, count?: number }` OK
             */
            postUnisenderCampaignsMessageId: function (messageId, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/unisender/campaigns/".concat(messageId), method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Автоматизация рассылок
             * @name GetUnisenderTemplatesTemplateId
             * @summary Метод возвращает информацию о заданном шаблоне
             * @request GET:/unisender/templates/{template_id}
             * @secure
             * @response `200` `{ id?: string, sub_user_login?: string, title?: string, description?: string, lang_code?: string, subject?: string, attachments?: string, screenshot_url?: string, fullsize_screenshot_url?: string, created?: string, updated?: string, message_format?: string, body?: string, type?: string, raw_body?: string }` OK
             */
            getUnisenderTemplatesTemplateId: function (templateId, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/unisender/templates/".concat(templateId), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * @description Метод для редактирования шаблона email письма для массовой рассылки, созданного с помощью понит POST /unisender/templates.
             *
             * @tags Автоматизация рассылок
             * @name PatchUnisenderTemplatesTemplateId
             * @summary Метод для редактирования шаблона email письма для массовой рассылки
             * @request PATCH:/unisender/templates/{template_id}
             * @secure
             */
            patchUnisenderTemplatesTemplateId: function (templateId, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/unisender/templates/".concat(templateId), method: 'PATCH', body: data, secure: true, type: ContentType.Json }, params));
            },
            /**
             * No description
             *
             * @tags Автоматизация рассылок
             * @name DeleteUnisenderTemplatesTemplateId
             * @summary Метод для удаления шаблона
             * @request DELETE:/unisender/templates/{template_id}
             * @secure
             */
            deleteUnisenderTemplatesTemplateId: function (templateId, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/unisender/templates/".concat(templateId), method: 'DELETE', secure: true }, params));
            },
            /**
             * @description Метод предназначен для тестирования и проверки выходных данных на соотвествествие и точности передачи. Для работы необходимо передавать {method} наименование, которое используеться в https://www.unisender.com/ru/support/category/api/. Напирмер, {method}=getLists.
             *
             * @tags Автоматизация рассылок
             * @name PostUnisenderDebugMethod
             * @summary Метод для отлаживания методов Unisender (он не отправляет запросы в API)
             * @request POST:/unisender/debug/{method}
             * @secure
             * @response `200` `{ success?: boolean, message?: string, debug?: { method_services?: (string)[], method?: string, encoding?: string, timeout?: number, lang?: string, parameters?: { api_key?: string, format?: string }, body?: (object)[], base_uri?: string } }` OK
             */
            postUnisenderDebugMethod: function (method, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/unisender/debug/".concat(method), method: 'POST', secure: true, format: 'json' }, params));
            },
        };
        _this.dzen = {
            /**
             * No description
             *
             * @tags Сюжеты Дзен.Новости
             * @name GetDzenNews
             * @summary Получение полного списка сюжетов
             * @request GET:/dzen/news
             * @secure
             * @response `200` `{ id?: number, rubric?: string, title?: string, text?: string, source_name?: string, logs?: { last?: { title?: string, time?: string, image?: string, sourceName?: string, url?: string, vector?: number, diff?: string, position?: number }, previous?: { title?: string, time?: string, image?: string, sourceName?: string, url?: string, vector?: number, diff?: string, position?: number } } }` OK
             */
            getDzenNews: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/dzen/news", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Сюжеты Дзен.Новости
             * @name GetDzenNewsId
             * @summary Получение полной информации по сюжету
             * @request GET:/dzen/news/{id}
             * @secure
             * @response `200` `{ id?: number, rubric?: string, link?: string, title?: string, text?: string, source_name?: string, tail?: ({ title?: string, sourceName?: string, vector?: number, diff?: string, position?: number })[], media?: ({ original?: { src?: string }, preview?: { src?: string }, source?: { name?: string } })[], stat?: { country?: string, region?: string, lastHourDocuments?: number, relatedStories?: number, totalDocuments?: number, positionInCountryTop?: number, positionInRegionalTop?: number, importance?: number, gtGeneral?: number, gtRegion?: number }, summarization?: ({ text?: string, url?: string, image?: string, sourceName?: string })[], node?: Article }` OK
             */
            getDzenNewsId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/dzen/news/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
        };
        _this.unacceptable = {
            /**
             * No description
             *
             * @tags Иностранные агенты или запрещенные организации
             * @name GetUnacceptable
             * @summary Получения списка иностранных агентов или запрещенных организаций
             * @request GET:/unacceptable
             * @secure
             * @response `200` `({ type?: string, name?: string, grounds?: string, info?: { id?: string, inn?: null, ogrn?: null, snils?: null, posted?: null, address?: null, resource?: (string)[], birthdate?: null, reg_number?: null, participants?: (string)[] }, inclusion?: number, fresh?: boolean, exclusion?: null, types?: ({ type?: { slug?: string, name?: string, description?: null, id?: number }, id?: number })[], keys?: ({ name?: string, id?: number })[], id?: number })[]` OK
             */
            getUnacceptable: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/unacceptable", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Иностранные агенты или запрещенные организации
             * @name GetUnacceptableLogs
             * @summary Получения логов по использованному поинту /articles/scanner
             * @request GET:/unacceptable/logs
             * @secure
             * @response `200` `{ user_id?: number, node_id?: number, result?: ({ id?: number, info?: { id?: any, inn?: any, ogrn?: any, snils?: any, address?: any, resource?: any, birthdate?: any, reg_number?: any, participants?: any }, keys?: ({ id?: number, name?: string })[], name?: string, grounds?: string, exclusion?: number, inclusion?: number })[], timestamp?: number, id?: number, user?: User }` OK
             */
            getUnacceptableLogs: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/unacceptable/logs", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Иностранные агенты или запрещенные организации
             * @name GetUnacceptableId
             * @summary Получение подробной информации по Иностранному агенту или запрещенной организации
             * @request GET:/unacceptable/{id}
             * @secure
             * @response `200` `{ type?: string, name?: string, grounds?: string, info?: { id?: string, inn?: null, ogrn?: null, snils?: null, posted?: null, address?: null, resource?: (string)[], birthdate?: null, reg_number?: null, participants?: (string)[] }, inclusion?: number, fresh?: boolean, exclusion?: null, types?: ({ type?: { slug?: string, name?: string, description?: null, id?: number }, id?: number })[], keys?: ({ name?: string, id?: number })[], id?: number }` OK
             */
            getUnacceptableId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/unacceptable/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Иностранные агенты или запрещенные организации
             * @name PatchUnacceptableId
             * @summary Добавление ключевых слов для иностранного агента или запрещенной организации
             * @request PATCH:/unacceptable/{id}
             * @secure
             * @response `200` `{ type?: string, name?: string, grounds?: string, info?: { id?: string, inn?: null, ogrn?: null, snils?: null, posted?: null, address?: null, resource?: (string)[], birthdate?: null, reg_number?: null, participants?: (string)[] }, inclusion?: number, fresh?: boolean, exclusion?: null, types?: ({ type?: { slug?: string, name?: string, description?: null, id?: number }, id?: number })[], keys?: ({ name?: string, id?: number })[], id?: number }` OK
             */
            patchUnacceptableId: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/unacceptable/".concat(id), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Иностранные агенты или запрещенные организации
             * @name PostUnacceptableScanner
             * @summary Публичный сканер
             * @request POST:/unacceptable/scanner
             * @secure
             * @response `200` `{ records?: (Unacceptable)[], persons?: (Unacceptable)[] }` OK
             */
            postUnacceptableScanner: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/unacceptable/scanner", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Иностранные агенты или запрещенные организации
             * @name GetUnacceptableRequest
             * @summary Получение списка заявок на использование сканера
             * @request GET:/unacceptable/request
             * @secure
             * @response `200` `({ user?: User, details?: { name?: string, email?: string, intent?: string, company?: string, position?: string, question?: string }, status?: number, created?: number, updated?: any, id?: number })[]` OK
             */
            getUnacceptableRequest: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/unacceptable/request", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Иностранные агенты или запрещенные организации
             * @name PostUnacceptableRequest
             * @summary Отправка заявки на предоставления доступа
             * @request POST:/unacceptable/request
             * @secure
             * @response `200` `{ message?: string }` OK
             */
            postUnacceptableRequest: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/unacceptable/request", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Иностранные агенты или запрещенные организации
             * @name PatchUnacceptableRequestId
             * @summary Предоставить/отозвать доступ к сканеру
             * @request PATCH:/unacceptable/request/{id}
             * @secure
             * @response `200` `({ user?: User, details?: { name?: string, email?: string, intent?: string, company?: string, position?: string, question?: string }, status?: number, created?: number, updated?: any, id?: number })[]` OK
             */
            patchUnacceptableRequestId: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/unacceptable/request/".concat(id), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
        };
        _this.franchises = {
            /**
             * No description
             *
             * @name GetFranchiseTariffs
             * @summary Get franchise tariffs
             * @request GET:/franchises/tariffs
             * @secure
             * @response `200` `(FranchiseTariff)[]` OK
             */
            getFranchiseTariffs: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/franchises/tariffs", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostFranchiseTariffs
             * @summary Create franchise tariff
             * @request POST:/franchises/tariffs
             * @secure
             * @response `200` `(FranchiseTariff)[]` OK
             */
            postFranchiseTariffs: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/franchises/tariffs", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetFranchisesTariffsId
             * @summary Get franchise tariff
             * @request GET:/franchises/tariffs/{id}
             * @secure
             * @response `200` `FranchiseTariff` OK
             */
            getFranchisesTariffsId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/franchises/tariffs/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PatchFranchisesTariffsId
             * @summary Update franchise tariff
             * @request PATCH:/franchises/tariffs/{id}
             * @secure
             * @response `200` `FranchiseTariff` OK
             */
            patchFranchisesTariffsId: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/franchises/tariffs/".concat(id), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetFranchisesSubscriptions
             * @summary Get franchise subscriptions
             * @request GET:/franchises/subscriptions
             * @secure
             * @response `200` `(FranchiseSubscription)[]` OK
             */
            getFranchisesSubscriptions: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/franchises/subscriptions", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostFranchiseSubscription
             * @summary Create franchise subscription
             * @request POST:/franchises/subscriptions
             * @secure
             * @response `200` `FranchiseSubscription` OK
             */
            postFranchiseSubscription: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/franchises/subscriptions", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetFranchiseSubscriptionId
             * @summary Get franchise subscription
             * @request GET:/franchises/subscriptions/{id}
             * @secure
             * @response `200` `FranchiseSubscription` OK
             */
            getFranchiseSubscriptionId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/franchises/subscriptions/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PatchFranchisesSubscriptionsId
             * @summary Update franchise subscription
             * @request PATCH:/franchises/subscriptions/{id}
             * @secure
             * @response `200` `FranchiseSubscription` OK
             */
            patchFranchisesSubscriptionsId: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/franchises/subscriptions/".concat(id), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
        };
        _this.finanse = {
            /**
             * No description
             *
             * @tags Контур.Фокус
             * @name GetFinanseStatistics
             * @summary Получение статистики по всем профилям
             * @request GET:/finanse/statistics
             * @secure
             */
            getFinanseStatistics: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/finanse/statistics", method: 'GET', query: query, secure: true }, params));
            },
            /**
             * No description
             *
             * @tags Контур.Фокус
             * @name PostFinanseStatistics
             * @summary Запрос на полчение по конкретному профилю
             * @request POST:/finanse/statistics
             * @secure
             */
            postFinanseStatistics: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/finanse/statistics", method: 'POST', body: data, secure: true, type: ContentType.Json }, params));
            },
            /**
             * No description
             *
             * @tags Контур.Фокус
             * @name GetFinanseStatisticsId
             * @summary Получение финансовых показателей
             * @request GET:/finanse/statistics/{id}
             * @secure
             */
            getFinanseStatisticsId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/finanse/statistics/".concat(id), method: 'GET', secure: true }, params));
            },
            /**
             * No description
             *
             * @tags Контур.Фокус
             * @name PatchFinanseStatisticsId
             * @summary Обновление финансовых показателей
             * @request PATCH:/finanse/statistics/{id}
             * @secure
             */
            patchFinanseStatisticsId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/finanse/statistics/".concat(id), method: 'PATCH', secure: true }, params));
            },
        };
        _this.draft = {
            /**
             * No description
             *
             * @tags Черновик
             * @name GetDraftId
             * @summary Получить черновик
             * @request GET:/draft/{id}
             * @secure
             * @response `200` `{ user?: User, timestamp?: number, diff?: object, id?: number }` OK
             */
            getDraftId: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/draft/".concat(id), method: 'GET', body: data, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Черновик
             * @name DeleteDraftId
             * @summary Удаление черновика
             * @request DELETE:/draft/{id}
             * @secure
             * @response `200` `{ message?: string }` OK
             */
            deleteDraftId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/draft/".concat(id), method: 'DELETE', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Черновик
             * @name PostDraft
             * @summary Создать черновик
             * @request POST:/draft
             * @secure
             * @response `200` `{ user?: object, timestamp?: number, diff?: object, id?: number }` OK
             */
            postDraft: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/draft", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
        };
        _this.drafts = {
            /**
             * No description
             *
             * @tags Черновик
             * @name GetDraftsArticle
             * @summary Получение списка черновиков по материалу
             * @request GET:/drafts/article
             * @secure
             * @response `200` `({ user?: User, timestamp?: number, diff?: object, id?: number })[]` OK
             */
            getDraftsArticle: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/drafts/article", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
        };
        _this.fields = {
            /**
             * No description
             *
             * @name GetFields
             * @summary Get fields list
             * @request GET:/fields
             * @secure
             * @response `200` `(Field)[]` OK
             */
            getFields: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/fields", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostFields
             * @summary Create field
             * @request POST:/fields
             * @secure
             * @response `200` `Field` OK
             */
            postFields: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/fields", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetFieldsId
             * @summary Get field
             * @request GET:/fields/{id}
             * @secure
             * @response `200` `Field` OK
             */
            getFieldsId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/fields/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PatchFieldsId
             * @summary Update field
             * @request PATCH:/fields/{id}
             * @secure
             * @response `200` `Field` OK
             */
            patchFieldsId: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/fields/".concat(id), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetFieldsIdInstances
             * @summary Get field instances
             * @request GET:/fields/{id}/instances
             * @secure
             * @response `200` `(FieldInstance)[]` OK
             */
            getFieldsIdInstances: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/fields/".concat(id, "/instances"), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name GetFieldsInstancesId
             * @summary Get field instance
             * @request GET:/fields/instances/{id}
             * @secure
             * @response `200` `FieldInstance` OK
             */
            getFieldsInstancesId: function (id, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/fields/instances/".concat(id), method: 'GET', secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PatchFieldsInstancesId
             * @summary Update field instance
             * @request PATCH:/fields/instances/{id}
             * @secure
             * @response `200` `FieldInstance` OK
             */
            patchFieldsInstancesId: function (id, data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/fields/instances/".concat(id), method: 'PATCH', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @name PostFieldsInstances
             * @summary Create field instance
             * @request POST:/fields/instances
             * @secure
             * @response `200` `FieldInstance` OK
             */
            postFieldsInstances: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/fields/instances", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
        };
        _this.visiting = {
            /**
             * No description
             *
             * @tags Рекомендательная система
             * @name PostVisitingNode
             * @summary Логирование просмотров
             * @request POST:/visiting/node
             * @secure
             * @response `200` `{ status?: string, message?: string, uuid?: string, node_id?: number }` OK
             */
            postVisitingNode: function (data, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/visiting/node", method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params));
            },
        };
        _this.recommender = {
            /**
             * No description
             *
             * @tags Рекомендательная система
             * @name GetRecommenderNode
             * @summary Получение рекомендаций
             * @request GET:/recommender/node
             * @secure
             * @response `200` `{ uuid?: string, articles?: (PubArticle)[] }` OK
             */
            getRecommenderNode: function (query, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/recommender/node", method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Рекомендательная система
             * @name GetRecommenderNodeUuid
             * @summary Получение единичной рекомендации
             * @request GET:/recommender/node/{uuid}
             * @secure
             * @response `200` `PubArticle` OK
             */
            getRecommenderNodeUuid: function (uuid, params) {
                if (params === void 0) { params = {}; }
                return _this.request(__assign({ path: "/recommender/node/".concat(uuid), method: 'GET', secure: true, format: 'json' }, params));
            },
        };
        return _this;
    }
    return Api;
}(HttpClient));

var duck = /*#__PURE__*/Object.freeze({
    __proto__: null,
    get ContentType () { return ContentType; },
    HttpClient: HttpClient,
    Api: Api
});

export { duck as Duck };
